var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L40 0L40 40L0 40L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "piscina-(1)-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L40 0L40 40L0 40L0 0Z",
    id: "Background",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.1020508 17.85254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9527 0L14.3673 0L14.3673 1.22445L27.0728 1.22445L32.5373 17.4694L1.25852 17.4694L6.71 1.22445L7.59187 1.22445L7.59187 0L5.8293 0L0 17.3708L0 18.6938L33.7959 18.6938L33.7959 17.3706L27.9527 0Z",
    id: "Polygon",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.258789 11.593262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.54937 0C0.695 0 0 0.695078 0 1.54945L0 8.10977L1.22453 8.10977L1.22453 1.54953C1.22453 1.37031 1.37031 1.22453 1.54945 1.22453C1.72867 1.22453 1.87437 1.37031 1.87437 1.54953L1.87437 3.11148L3.09883 3.11148L3.09883 1.54953C3.09883 0.695078 2.40375 0 1.54937 0L1.54937 0Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.631836 11.593262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.54938 0C0.695 0 0 0.695078 0 1.54945L0 8.10977L1.22453 8.10977L1.22453 1.54953C1.22453 1.37031 1.37031 1.22453 1.54953 1.22453C1.72875 1.22453 1.87445 1.37031 1.87445 1.54953L1.87445 3.11148L3.09891 3.11148L3.09891 1.54953C3.09883 0.695157 2.40375 0 1.54938 0L1.54938 0Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.143066 15.321777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.87758 0L1.87758 1.22453L0 1.22453L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.143066 17.85205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.87758 0L1.87758 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 15.321777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9257 0L17.4694 0L17.4694 1.22445L32.0527 1.22445L38.7755 20.7287L38.7755 23.102L1.22445 23.102L1.22445 20.7286L7.93414 1.22445L10.6939 1.22445L10.6939 0L7.06047 0L0.0332813 20.427L0 20.5238L0 24.3266L40 24.3266L40 20.5237L32.9257 0Z",
    id: "Polygon",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.693848 21.607422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L6.20406 0L6.20406 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.89795 23.484863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.44898 0L2.44898 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.917969 27.158203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.44899 0L2.44899 1.22453L0 1.22453L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.3671875 30.995117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L10.6123 0L10.6123 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.979492 32.219727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L3.75508 0L3.75508 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.082031 32.87256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.61227 0L2.61227 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.428711 29.770508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.53062 0L2.53062 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.326172 20.954102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.53062 0L2.53062 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.856934 22.832031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.87758 0L1.87758 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.856934 25.934082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.87758 0L1.87758 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(29.306152 27.811523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.61227 0L2.61227 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 12.872559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L10.6939 0L10.6939 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(19.34668 12.872559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20.653 0L20.653 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 7.8115234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L40 0L40 1.22445L0 1.22445L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 0.3515625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3164 5.58234C33.9882 2.4575 31.3327 0 28.1155 0C24.8985 0 22.243 2.45758 21.9147 5.58234L0 5.58234L0 6.8068L40 6.8068L40 5.58234L34.3164 5.58234L34.3164 5.58234ZM23.1484 5.5825C23.4685 3.11781 25.5734 1.22461 28.1157 1.22461C30.658 1.22461 32.7629 3.11781 33.083 5.5825L23.1484 5.5825L23.1484 5.5825Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPool);
export default __webpack_public_path__ + "static/media/pool.1915fd4419947b489d4c11e2ef2fbcb1.svg";
export { ForwardRef as ReactComponent };